import { ApiConnectionFirmMapping } from '@tassat/fred-extended-definitions';

import { ApiFirmConnectionsGrid } from './apiConnectionsFirmGrid';

export interface IApiConnectionsFirmGridProps {
    apiConnections: ApiConnectionFirmMapping[];
}

export default ApiFirmConnectionsGrid;